module.exports = "fragment ItemizedCostFragment on ItemizedCost {\n  total {\n    ...PriceFragment\n  }\n  entries {\n    ...LabeledPriceFragment\n  }\n}\n"